// topCountries.js

const topCountries = [
    { name: "United States", code: "USA", callingCode: "+1" },
    { name: "Canada", code: "CA", callingCode: "+1" },
    { name: "United Kingdom", code: "GB", callingCode: "+44" },
    { name: "Germany", code: "DE", callingCode: "+49" },
    { name: "France", code: "FR", callingCode: "+33" },
    { name: "Australia", code: "AU", callingCode: "+61" },
    { name: "India", code: "IN", callingCode: "+91" },
    { name: "China", code: "CN", callingCode: "+86" },
    { name: "Japan", code: "JP", callingCode: "+81" },
    { name: "Brazil", code: "BR", callingCode: "+55" },
    { name: "South Korea", code: "KR", callingCode: "+82" },
    { name: "Russia", code: "RU", callingCode: "+7" },
    { name: "Italy", code: "IT", callingCode: "+39" },
    { name: "Mexico", code: "MX", callingCode: "+52" },
    { name: "South Africa", code: "ZA", callingCode: "+27" },
    { name: "Netherlands", code: "NL", callingCode: "+31" },
    { name: "Turkey", code: "TR", callingCode: "+90" },
    { name: "Saudi Arabia", code: "SA", callingCode: "+966" },
    { name: "Argentina", code: "AR", callingCode: "+54" },
    { name: "Sweden", code: "SE", callingCode: "+46" },
    { name: "Belgium", code: "BE", callingCode: "+32" },
    { name: "Switzerland", code: "CH", callingCode: "+41" },
    { name: "Poland", code: "PL", callingCode: "+48" },
    { name: "Thailand", code: "TH", callingCode: "+66" },
    { name: "Indonesia", code: "ID", callingCode: "+62" },
    { name: "Norway", code: "NO", callingCode: "+47" },
    { name: "Israel", code: "IL", callingCode: "+972" },
    { name: "Austria", code: "AT", callingCode: "+43" },
    { name: "Denmark", code: "DK", callingCode: "+45" },
    { name: "Ireland", code: "IE", callingCode: "+353" },
    { name: "Malaysia", code: "MY", callingCode: "+60" },
    { name: "Singapore", code: "SG", callingCode: "+65" },
    { name: "Greece", code: "GR", callingCode: "+30" },
    { name: "Portugal", code: "PT", callingCode: "+351" },
    { name: "New Zealand", code: "NZ", callingCode: "+64" },
    { name: "Hungary", code: "HU", callingCode: "+36" },
    { name: "Czech Republic", code: "CZ", callingCode: "+420" },
    { name: "Philippines", code: "PH", callingCode: "+63" },
    { name: "Colombia", code: "CO", callingCode: "+57" },
    { name: "Chile", code: "CL", callingCode: "+56" },
    { name: "Finland", code: "FI", callingCode: "+358" },
    { name: "Vietnam", code: "VN", callingCode: "+84" },
    { name: "Romania", code: "RO", callingCode: "+40" },
    { name: "Pakistan", code: "PK", callingCode: "+92" },
    { name: "Peru", code: "PE", callingCode: "+51" },
    { name: "Bangladesh", code: "BD", callingCode: "+880" },
    { name: "Egypt", code: "EG", callingCode: "+20" },
    { name: "Ukraine", code: "UA", callingCode: "+380" },
    { name: "Nigeria", code: "NG", callingCode: "+234" },
    { name: "Morocco", code: "MA", callingCode: "+212" },
    { name: "Kenya", code: "KE", callingCode: "+254" },
    { name: "Ethiopia", code: "ET", callingCode: "+251" },
    { name: "United Arab Emirates", code: "AE", callingCode: "+971" },
    { name: "Qatar", code: "QA", callingCode: "+974" }
 ];
 
 export default topCountries;
 